import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MappingComponent} from '../../mapping/mapping.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-stop-drawing',
    templateUrl: './stop-drawing.component.html',
    styleUrls: ['./stop-drawing.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class StopDrawingComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<MappingComponent>,
  public dialog: MatDialog,
  public translate: TranslateService) { }

  ngOnInit(): void {
  }

  stopDrawing() {
    this.dialogRef.close({"option": "ok"});
  }

  cancel(): void {
    this.dialogRef.close({"option": "cancel"});
  }

}
